export default __webpack_public_path__ + "static/media/point.78bf84b0.png";